import {
  BaseDialog,
  FlexBox,
  Spacer,
} from '@airship-platform/jam-web/components';
import { Box, Typography } from '@mui/material';
import { InstalledEquipment } from '../../../../../app/data-access/appointmentEquipment';

const SeeAllAssetsExistingSystemModal: React.FC<{
  open: boolean;
  equipments: InstalledEquipment[];
  onClose: () => void;
}> = ({ open, equipments, onClose }) => (
  <BaseDialog open={open} title={''} onClose={() => onClose()}>
    {equipments.map((equipment) => (
      <FlexBox flexDirection="column" key={equipment.locationEquipmentId}>
        <Typography variant={'h4'}>{equipment.name}</Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: `repeat(2, 1fr)`,
            gap: 1,
          }}
        >
          {equipment.assets
            .filter((asset) => asset.type.toLowerCase() === 'image')
            .map((asset) => (
              <Box
                key={asset.url}
                component="img"
                src={asset.url}
                alt={'Preview'}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            ))}
        </Box>
        <Spacer height={'3rem'} />
      </FlexBox>
    ))}
  </BaseDialog>
);
export default SeeAllAssetsExistingSystemModal;
